import { Paper, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useRouter } from 'next/router';

import { VerifyReservation } from 'components/VerifyReservation/VerifyReservation';
import { useRelativeUrl } from 'hooks/useRelativeUrl';
import { ReduxState } from 'ducks';

import styles from './VerifyForReservationDetails.module.css';

export const VerifyForReservationDetails = () => {
  const { t, i18n } = useTranslation();
  const router = useRouter();

  const initialAgentReference = router.query.app as string;

  const myPageFeatureEnabled = useSelector(
    (state: ReduxState) =>
      state.server.settings.all?.subscriptions?.some(
        (subscription) =>
          subscription.key === 'feature-guest-my-page' && subscription.status === 'ACTIVE'
      ) ?? false
  );

  const redirectUrl = useRelativeUrl(`/reservations?lng=${i18n.language}`);

  if (!myPageFeatureEnabled) {
    return <Typography variant="h3">{t('Page not available')}</Typography>;
  }

  return (
    <article className={styles['base-book']}>
      <div className={styles['base-book__main']}>
        <Paper className={styles['main-paper']}>
          <Typography component="h1" variant="h4" align="center">
            {t('Verify Reservation to Continue')}
          </Typography>
          <div className={styles['form-container']}>
            <VerifyReservation
              redirectUrl={redirectUrl}
              allowAllReservationStatuses
              requireAgentReference
              initialValues={{
                agentReference: initialAgentReference,
              }}
            />
          </div>
        </Paper>
      </div>
    </article>
  );
};
